import { FC } from 'react'
import PrimaryButton from 'components/atoms/Button/PrimaryButton';
import ModalAtom, { ModalAtomProps } from 'components/atoms/ModalAtom';
import SpaceAtom from 'components/atoms/SpaceAtom';

interface Props extends ModalAtomProps {
  text: string;
  list: string[];
  mainButtonText: string;
}

const FailedSensorUpdatesModal: FC<Props> = ({ title, mainButtonText, text, list, onCancel, onOk, ...props }) => {
  return (
    <ModalAtom
      {...props}
      title={<SpaceAtom>{title}</SpaceAtom>}
      onCancel={onCancel}
      destroyOnClose
      width={'50%'}
      footer={[
        <PrimaryButton key={'submit'} onClick={onOk} title={mainButtonText} />,
      ]}
    >
      <div>{text}</div>
      <ul>
        {list.map((listItem, key) => {
          return (
            <li key={key}>{listItem}</li>
          )
        })}
      </ul>
    </ModalAtom>
  );
}

export default FailedSensorUpdatesModal;
